import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-gallery-page-container',
  imports: [CommonModule,RouterModule],
  standalone: true,
  templateUrl: './gallery-page-container.component.html',
  styleUrl: './gallery-page-container.component.scss'
})
export class GalleryPageContainerComponent {

}
